enum GameType {
  math = 'math',
  attention = 'attention',
  memory = 'memory',
  spatial = 'spatial',
  executiveFunctions = 'executiveFunctions'
}

interface IGamesKeys {
  [game: string]: {
    [gameName: string]: string[]
  }
}

export const gamesInTypes: IGamesKeys = {
  [GameType.math]: {
    ans: ['ans'],
    subitizing: ['subitizing'],
    symbolic: ['symbolic']
  },
  [GameType.attention]: {
    sart: ['sart', 'sart_reverse'],
    card_sort: ['card_sort']
  },
  [GameType.memory]: {
    corsi_blocks: ['corsi_blocks'],
    corsi_blocks_reverse: ['corsi_blocks_reverse']
  },
  [GameType.spatial]: {
    mental_rotation: ['mental_rotation']
  }
}

interface IGamesInTalentMapKeys {
  [game: string]: {
    [gameName: string]: string
  }
}

export const gamesInCurrentTalentMap: IGamesInTalentMapKeys = {
  [GameType.math]: {
    ans: 'non_symbolic_numerical_representation',
    subitizing: 'enumeration',
    symbolic: 'symbolic_numerical_representation'
  },
  [GameType.attention]: {
    sart: 'continuous_performance_attention',
    sart_reverse: 'inhibition',
    card_sort: 'planning'
  },
  [GameType.memory]: {
    corsi_blocks: 'visual_spatial_short_term_memory',
    corsi_blocks_reverse: 'visual_spatial_working_memory'
  },
  [GameType.spatial]: {
    mental_rotation: 'spatial_abilities'
  },
  ['executive_functions']: {
    card_sort: 'planning',
    sart_reverse: 'inhibition',
    corsi_blocks_reverse: 'visual_spatial_working_memory'
  }
}

export default GameType



// WEBPACK FOOTER //
// ./src/data/games/gameTypes.ts